import {ApplicationScope, TaskCategory, TaskStatus} from '@modifi/enums'

export const LOCAL_STORAGE_TASK_ITEMS_PER_PAGE = '@modifi:tasks:itemsPerPage'

export enum TaskCommonActions {
  RESOLVE_TASK = 'resolve-task',
  REOPEN_TASK = 'reopen-task',
  ASSIGN_TASK = 'assign-task',
  LEAVE_TASK = 'leave-task',
  SET_TO_TODO = 'set-to-todo',
  ASSIGN_TO_ACCOUNT_OWNER = 'assign-to-account-owner',
}

export type ContextParametersType = {
  key: string
  value: string
}

export type Task = {
  externalId: string
  externalCompanyId: string
  category: TaskCategory
  scope?: ApplicationScope
  companyName: string
  dueDateOn: string
  createdOn: string
  status: TaskStatus
  assignee?: string
  internalNote?: string
  internalNoteModifiedBy?: string
  relatedEntities?: Array<{
    name?: string
    key?: string
  }>
  contextParameters?: ContextParametersType[]
}

/** Fields of a task that can be changed through the task update endpoint. */
export type TaskUpdate = Partial<Pick<Task, 'status' | 'assignee' | 'internalNote'>>

export const pageSizeOptions = [
  {
    value: 20,
    label: 'Show 20 results',
  },
  {
    value: 50,
    label: 'Show 50 results',
  },
  {
    value: 100,
    label: 'Show 100 results',
  },
]
